import { Navigate, Outlet } from 'react-router-dom'
import { checkPermission } from '../utils/checkPermission'
import { ReactNode } from 'react'

interface ProductRouteProps {
  children: ReactNode
}

const ProductRoute = ({ children }: ProductRouteProps) => {
  if (!checkPermission('Products')) {
    return <Navigate to='/unauthorized' replace />
  }
  return <>{children}</>
}

export { ProductRoute } 